
import vuedraggable from 'vuedraggable'
import { ossUploadFile } from '@/utils/uploader'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
	components: { vuedraggable, ElImageViewer },
	props: {
		tip: {
			type: String,
			default: '仅支持jpg.png格式，分辨率为16：9'
		},
		value: {
			// 初始化图片
			type: [String, Array]
		},
		size: {
			type: Number,
			default: 500
		},
		limit: {
			type: Number,
			default: 999
		},
		goodsType: {
			type: String
		},
		upLoadType: {
			type: String
		}
	},
	data() {
		return {
			loading: false,
			dialogVisible: false,
			fileList: [], //页面显示的数组
			dialogImageUrl: null,
			maxFileLength: 0,
			preIniIndex: 0,
			imageUrl: []
		}
	},
	watch: {
		value(newValue, oldVal) {
			if (newValue != oldVal) {
				this.formatValue()
			}
		}
	},
	created() {
		this.formatValue()
	},
	methods: {
		chooseFile() {
			// 清空上传的文件
			this.$refs.uploader.value = ''
			this.$refs.uploader.click()
		},
		async onChange(e) {
			const files = [...e.target.files]
			if (files.length > 20) {
				this.$message.warning(`上传数量在0-20之间`)
				return
			}
			// 检查图片
			const rightList = files.filter(file => this.beforeUpload(file))
			if (!rightList.length) return
			// 开始上传
			this.loading = true

			let pList = await ossUploadFile(this.upLoadType, rightList, {
				ContentType: 'image/jpeg',
				hideToast: true,
				progress: (percentage, cpt) => {
					this.percentage = percentage
				}
			}) //rightList.map(file => )
			pList = Array.isArray(pList) ? pList : [pList]
			Promise.all(pList).then(fileDatas => {
				this.uploadComplete(fileDatas)
				this.loading = false
			})
		},
		// 上传之前
		beforeUpload(file) {
			// 格式校验
			const isRightType = ['image/png', 'image/webp', 'image/jpeg'].includes(file.type)
			if (!isRightType) {
				this.$message.warning(`${file.name} 不是JPG/PNG格式`)
				return false
			}

			// 格式校验
			const isRightSize = file.size / 1024 / 1024 > this.size
			if (isRightSize) {
				this.$message.warning(`${file.name} 超过 ${this.size}KB`)
				return false
			}

			return true
		},
		// 开始上传
		// startUpload(file) {
		// 	return ossUploadFile(this.upLoadType, file, {
		// 		ContentType: 'image/jpeg',
		// 		hideToast: true,
		// 		progress: (percentage, cpt) => {
		// 			this.percentage = percentage
		// 		}
		// 	}).then(fileData => {
		// 		console.log(fileData, 'fileData')
		// 	})
		// },
		// 上传完成
		uploadComplete(fileDatas) {
			// 过滤无效数据
			fileDatas = fileDatas.filter(item => item)
			// 添加uid，用于拖拽唯一key
			fileDatas.forEach(item => (item.uid = item.url))
			// 只允许上传一张，则单张覆盖
			if (this.limit > 1) {
				this.fileList.push(...fileDatas)
			} else {
				// 多张push
				this.fileList = [...fileDatas]
			}
			// 向父组件传递数据
			this.emitValue()
			this.$message.success('上传成功')
		},
		// 格式处理
		formatValue() {
			if (this.value) {
				let fileList = this.value
				if (typeof this.value == 'string') {
					fileList = this.value.split(',')
				}
				this.fileList = fileList.map(url => ({ url, uid: url }))
			} else {
				this.fileList = []
			}
		},
		// 预览图片
		previewImage(val) {
			this.dialogImageUrl = val.url
			this.showPreviewImg(val.url)
			this.dialogVisible = true
			// 禁止页面滑动
			const m = e => {
				e.preventDefault()
			}
			document.body.style.overflow = 'hidden'
			document.addEventListener('touchmove', m, false)
		},
		// 关闭查看器
		closeViewer() {
			this.dialogVisible = false
			// 恢复页面滑动
			const m = e => {
				e.preventDefault()
			}
			document.body.style.overflow = 'auto'
			document.removeEventListener('touchmove', m, true)
		},
		// 设置点击哪张图预览哪张图片方法
		showPreviewImg(url) {
			const list = this.fileList.map(item => item.url)
			this.imageUrl = list
			for (let index in list) {
				if (list[index] === url) {
					this.preIniIndex = Number(index)
					break
				}
			}
		},
		// 删除图片
		delImage(index) {
			this.fileList.splice(index, 1)
			this.emitValue()
		},
		// 派发数据
		emitValue() {
			if (this.limit === 1) {
				if (this.fileList.length) {
					this.$emit('input', this.fileList[0].url.toString())
				} else {
					this.$emit('input', '')
				}
			} else {
				this.$emit(
					'input',
					this.fileList.map(({ url }) => url)
				)
			}
		}
	}
}
